<template>
  <v-container id="attendance-list">
    <v-form @submit.prevent="onSubmit" ref="form">
      <v-container>
        <h2 class="w-100 text-center title-insert">
          {{ tabId > 0 ? "Editar" : "Adicionar" }} Marco Legal
        </h2>
        <v-row>
          <v-col>
            <v-text-field
              label="Tipo"
              name="tipo"
              type="text"
              :rules="rules"
              required
              v-model="marco.tipo"
            ></v-text-field>
          </v-col>

          <v-col>
            <v-text-field
              label="Número"
              name="numero"
              type="text"
              :rules="rules"
              required
              v-model="marco.numero"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              label="Ano"
              name="ano"
              type="number"
              :rules="rules"
              required
              v-model="marco.ano"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field
              label="Tema"
              name="tema"
              type="text"
              v-model="marco.tema"
              required
              :rules="rules"
              background-color="white"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field
              label="Responsável"
              name="responsavel"
              type="text"
              v-model="marco.responsavelOrgao"
              required
              :rules="rules"
              background-color="white"
            />
          </v-col>
          <v-col>
            <v-checkbox
              v-model="marco.atualizado"
              id="atualizado"
              color="primary"
              label="Ativos"
            />
          </v-col>
        </v-row>

        <v-text-field
          label="Link"
          name="link"
          type="text"
          v-model="marco.link"
          required
          :rules="rules"
          background-color="white"
        />

        <v-textarea
          label="Oportunidades"
          name="oportunidades"
          type="text"
          v-model="marco.oportunidades"
          required
          :rules="rules"
          background-color="white"
        />
        <v-row class="row-buttons mt-4">
          <v-btn
            type="button"
            color="error"
            text
            style="margin-left: 10px"
            @click="goToList()"
          >
            Cancelar
          </v-btn>
          <v-btn color="primary" type="submit"> Salvar </v-btn>
        </v-row>
      </v-container>
    </v-form>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { AppCityHeader } from "@/modules/city";

import { marcoLegalApi } from "../Api/marcoLegal";
export default {
  components: {
    AppCityHeader,
  },
  data() {
    return {
      marco: {},
      payload: {
        municipioId: this.$route.params.id,
      },
      isEdit: false,
      tabType: this.$route.params.tab,
      tabId: this.$route.params.tabId,
      rules: [(v) => !!v || "Campo Obrigatório"],
    };
  },
  mounted() {
    if (this.tabId > 0) {
      this.setLoading(true);
      marcoLegalApi
        .find(this.tabId)
        .then(({ data }) => {
          this.marco = data;
          this.setLoading(false);
        })
        .catch((err) => {
          this.$notification.error("Erro ao encontrar Marco Legal");
          console.log("Erro no mounted ", err);
          this.setLoading(false);
        });
    }
  },
  methods: {
    ...mapActions(["setLoading"]),
    goToList() {
      this.$router.push(
        `/cidade/${this.payload.municipioId}/agenteTerritorial/${this.tabType}`
      );
    },
    async onSubmit() {
      const valid = await this.check();

      if (!valid) return;
      this.marco.municipioId = this.payload.municipioId;

      if (this.tabId > 0) {
        marcoLegalApi
          .update(this.marco)
          .then(() => {
            this.$notification.success("Marco Legal editado com sucesso!");
            this.goToList();
          })
          .catch((err) => {
            this.$notification.error("Erro ao editar Marco Legal");
            console.log("Erro no submit ", err);
          });
      } else {
        marcoLegalApi
          .create(this.marco)
          .then(() => {
            this.$notification.success("Marco Legal criado com sucesso!");
            this.goToList();
          })
          .catch((err) => {
            this.$notification.error("Erro ao criar Marco Legal");
            console.log("Erro no submit ", err);
          });
      }
    },
    async check() {
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
  },
};
</script>
<style scoped>
.title-insert {
  color: #5c8bb9;
}
.row-buttons {
  display: flex;
  justify-content: flex-end;
}
fieldset {
  padding: 10px;
  margin-bottom: 30px;
  border: 1px solid rgba(0, 0, 0, 0.87);
}
legend {
  padding: 10px;
  color: rgba(0, 0, 0, 0.6);
}
</style>
